import { MilestoneListingDto } from "../../milestones/milestones.objects";
import { getData } from "./site.utilities";

export class CTMSSiteMilestonesSection {

    url: string;
    studyIds: number[];
    baseSelector = '#milestone-table-study';
    tableMap = new Map<number, any>();

    statusClick: (siteStudyId: number, statusId: number, studyName: string) => void;

    showAddButton: boolean;

    editCallback: (response) => void;
    addCallback: (response) => void;

    constructor(handlerUrl: string, studyIds: number[] = [], showAddButton = false){
        this.url = handlerUrl;
        this.studyIds = studyIds;
        this.showAddButton = showAddButton;

        this.initialize();
        this.bindEvents();
    }

    initialize() {

        this.tableMap = new Map<number, any>();

        $('#milestonesSection button[data-toggle="tab"]').on('shown.bs.tab', (e) => {
            const studyId = Number.parseInt($(e.target).data('target').slice(6));
            const table = this.getTable(studyId);
            if (table) table.draw();
        });

        // select first study tab
        $('#milestonesSection .ctms-st-menu-item:first-child .nav-link').tab('show');

    }

    bindEvents() {
        $(document).on('click', `#milestonesSection .ctms-table-col-actions .ctms-icon-pencil`, async (evt) => {
            if (this.editCallback) {
                const row = $(evt.target).closest('tr');
                const t = $(evt.target).closest('table');
                const m = $(t).DataTable().row(row).data();

                this.editCallback(m);
            }
        });

        $(document).on('click', `#milestonesSection .ctms-table-col-actions .ctms-icon-plus`, async (evt) => {
            if (this.addCallback) {
                const row = $(evt.target).closest('tr');
                const t = $(evt.target).closest('table');
                const m = $(t).DataTable().row(row).data();

                this.addCallback(m);
            }
        });
    }

    getTable(studyId): any {

        if (this.tableMap.has(studyId)) {
            return this.tableMap.get(studyId);
        } else {
            const table = $(this.baseSelector + studyId).DataTable({
                dom: 'rtip',
                autoWidth: false,
                info: false,
                paging: false,
                search: true,
                scrollX: true,
                scrollY: '200px',
                scrollCollapse: true,
                orderCellsTop: true,
                order: [[0, 'asc']],
                columns: [
                    { data: 'OrderId', title: '', visible: false },
                    { data: 'Id', title: '', visible: false },
                    { data: 'MilestoneCategoryAndName', title: 'Milestone', orderable: false },
                    { data: 'CTMSOperationMilestoneStatusName', title: 'Status', orderable: false},
                    { data: 'ExpectedDueDate', title: 'Due Date', orderable: false },
                    { data: 'CompletionDate', title: 'Completed Date', orderable: false },
                    {
                        data: null,
                        title: '',
                        className: 'ctms-table-col-actions',
                        orderable: false,
                        render: this.getActionColumnMarkup.bind(this)
                    }
                ],
                rowCallback: (row: any, data: MilestoneListingDto) => {

                    if (data.NotApplicable) {
                        row.classList.add('ctms-row-notapplicable');
                    } else if (data.ExpectedDueDate && !data.CompletionDate) {
                        const d = new Date(data.ExpectedDueDate);
                        const t = new Date();
                        if (d < t) row.classList.add('ctms-row-overdue') ;
                    }
                }
            });

            this.tableMap.set(studyId, table);
            return table;
        }
    }

    async loadData() {
        $('#milestoneSectionLoading').removeClass('d-none');

        const response = await getData(this.url);

        this.studyIds = response.studies.map((s) => s.StudyId);

        this.studyIds.forEach(sid => {
            const siteStudy = response.studies.find((s) => s.StudyId === sid);
            const statusName = siteStudy?.StatusName;
            $(`#milestone-statustext-study${sid}`).text(statusName);

            if (this.showAddButton) {
                $(document).on('click', `#milestone-status-study${sid} button`, (evt) => {
                    this.statusClick(siteStudy.Id, siteStudy.StatusId, siteStudy.StudyName);
                });
            } else {
                $(`#milestone-status-study${sid} button`).hide();
            }

            const milestones = response.milestones.filter(m => m.StudyId === sid);
            const table = this.getTable(sid);
            table.clear();
            table.rows.add(milestones).draw();
        });

        $('#milestoneSectionLoading').addClass('d-none');
    }

    private getActionColumnMarkup(data, type, row) {
        const addButton = (this.showAddButton) ? `<button title="Add" class="ml-2"><i class="ctms-icon-plus"></i></button>` : ``;
        return `<button title="Edit"><i class="ctms-icon-pencil"></i></button>${addButton}`;
    }
}